module.exports = __webpack_public_path__ + "static/media/6.1aaa4629.png";